import { RemoteRunnable } from "@langchain/core/runnables/remote";
import { AIMessage } from "./App";

const BASE_URL = process.env.REACT_APP_API_URL;
if (!BASE_URL) {
  throw new Error("REACT_APP_API_URL environment variable is not set");
}

const API_ENDPOINT = BASE_URL + "/chat";
const STATIC_FILES_ENDPOINT = BASE_URL + "/data";

export interface Source {
  file_name: string;
  file_location?: string;
}

interface SourceOld {
  file_location?: string;
  file_origin_url?: string;
  title: string;
}

export interface ChatMessage {
  user_message: string;
  ai_response: string;
}

type OnMessageReceived = (message: string, runId: string) => void;
type OnComplete = (sources: Source[]) => void;
type OnError = (errorMessage: string) => void;

// Function to send a message to the API and stream the response
export const sendMessageToAPI = async (
  message: string,
  chatHistory: ChatMessage[],
  onMessageReceived: OnMessageReceived,
  onMessageReceivedAdditive: OnMessageReceived,
  onComplete: OnComplete,
  onError: OnError,
) => {
  try {
    // Create a new instance of RemoteRunnable
    const remoteChain = new RemoteRunnable({
      url: API_ENDPOINT,
    });

    // Stream the response back to the UI
    const stream = remoteChain.streamEvents(
      {
        input: message,
        chat_history: chatHistory,
      },
      {
        version: "v1",
      },
    );

    let sources: Source[] = [];
    let runId: string = "";

    for await (const chunk of stream) {
      const content = chunk.data?.chunk;
      // console.log(`Event: ${chunk.event}, Content: ${content}`)

      if (chunk.event === "on_chain_start" && chunk.name === "/chat") {
        runId = chunk.run_id;
      }
      if (
        chunk.event === "on_chain_stream" &&
        chunk.name === "/chat" &&
        content
      ) {
        onMessageReceived(content.answer, runId);
        // sources = content.sources_file_name.map((source: string) => ({
        //   file_name: source,
        //   file_location: `${STATIC_FILES_ENDPOINT}/${source}`,
        // }));
      }

      if (
        chunk.event === "on_chat_model_stream" &&
        (chunk.name === "AnswerLLM" || chunk.name === "AgentLLM") &&
        content
      ) {
        // This is only for Tavily
        // onMessageReceivedAdditive(content.content, runId);
      }
      if (chunk.event === "on_chain_end" && chunk.name === "/chat") {
        sources = chunk?.data?.output?.sources.map((source: SourceOld) => ({
          file_name: source.title,
          file_location:
            source.file_origin_url ??
            `${STATIC_FILES_ENDPOINT}/${source.title}`,
        }));
      }
    }

    console.log(sources);
    onComplete(sources);
  } catch (error) {
    console.error("Error sending message to API:", error);
    onError("Bohužel nastala chyba na naší straně. Zkuste to prosím později.");
  }
};

export const sendFeedbackToAPI = async (
  message: AIMessage,
  onError: OnError,
) => {
  try {
    const score = message.feedback === "positive" ? 1 : 0;
    console.log(message);
    const response = await fetch(`${API_ENDPOINT}/feedback`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        run_id: message.runId,
        score: score,
        key: "correctness",
      }),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    console.log(data);
  } catch (error) {
    console.error("Error sending message to API:", error);
    onError("Bohužel nastala chyba na naší straně. Zkuste to prosím později.");
  }
};
